<template>
  <!-- ref="dialogRef" теперь будет ссылаться на переменную из setup -->
  <q-dialog
    ref="dialogRef"
    no-shake
    full-width
    @hide="onDialogHide"
  >
    <finance-info-component
      :bill-id="existingBillId"
      :is-payment="isPayment"
      @close="(payload) => handleClose(payload)"
    />
  </q-dialog>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-facing-decorator'
import { useDialogPluginComponent } from 'quasar'
import FinanceInfoComponent from '../info-dialogs/FinanceInfoComponent.vue'

@Component({
  components: { FinanceInfoComponent },
  emits: [...useDialogPluginComponent.emits],
  // Используем setup для корректной инициализации хука диалога
  setup() {
    const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
    return {
      dialogRef,
      onDialogHide,
      onDialogOK,
      onDialogCancel
    }
  }
})
export default class BillInfoDialog extends Vue {
  @Prop({ required: true }) existingBillId!: string
  @Prop({ required: true }) isPayment!: string

  // Эти свойства будут доступны из setup() автоматически в этом экземпляре
  declare dialogRef: any
  declare onDialogHide: () => void
  declare onDialogOK: (payload?: any) => void

  handleClose(payload?: { hadChanges?: boolean }) {
    this.onDialogOK(payload)
  }
}
</script>
